import styled from 'styled-components';

const MultiSelectTriggerStyled = styled.button<HTMLButtonElement>`
    height: fit-content;
    background-color: #fff;
    padding: 8px;
    cursor: pointer;
    outline: none;
    border: none;
`;

export default MultiSelectTriggerStyled;